/**
 * Created by Andste on 2018/5/7.
 */

import both from './storage'
import store from '@/store'
import router from '@/router'
import * as API_USER from '@/api/user'
import { MessageBox } from 'element-ui'
import lang from '@/assets/lang'
let langCountry = both.storage.get('langCountry')
langCountry = langCountry.length == 0 ? 'cn' : langCountry

/**
 * 检查token：
 * 1. user/accessToken/refreshToken都不存在。
 *    表示用户没有登录，没有权限，重定向到登录页
 * 2. 不存在accessToken，但是user/refreshToken存在。
 *    表示accessToken过期，需要重新获取accessToken。
 *    如果重新获取accessToken返回token失效错误，说明已被登出。
 * @param options
 * @returns {Promise<any>}
 */
export default function checkToken(options) {
  // user
  // const user = both.storage.get('user')
  // 访问Token
  const accessToken = both.storage.get('token').access_token
  const accessTokenTime = both.storage.get('token').access_token_timeout
  // 刷新Token
  const refreshToken = both.storage.get('token').refresh_token
  const refreshTokenTime = both.storage.get('token').refresh_token_timeout
  // 返回异步方法
  // 跳转地址
  const backURL = options == undefined ? router.currentRoute.fullPath : options.fullPath
  const authBackUrl = !!both.storage.get('authBackUrl').length ? both.storage.get('authBackUrl') : ''

  return new Promise((resolve, reject) => {
    /**
     * 如果accessToken、user、refreshToken都存在。
     * 说明必要条件都存在，可以直接通过，并且不需要后续操作。
     */
    if (accessToken && refreshToken) {
      const nowTime = new Date().getTime()
      if (nowTime <= accessTokenTime) {
        // 时间短，不需要验证
        resolve()
      } else if (nowTime > accessTokenTime && nowTime <= refreshTokenTime ){
        // 刷新token
        let params = {
          refreshToken: refreshToken
        }
        API_USER.refreshToken(params).then(res=> {
          store.dispatch('token', res.data)
          resolve()
        }).catch(()=> {
          // if ( router.currentRoute.name != 'Index' ) {
            router.push({ path: `/index?forward=${btoa(encodeURI((backURL)))}` })
          // }
        })
      }else{
        // token过期，重新登录
        MessageBox.alert(lang[langCountry].Your_login_status_has_expired_please_log_in_again, lang[langCountry].Permission_error, {
          type: 'error',
          callback: () => {
            store.dispatch('token', {})
            store.dispatch('user', {})
            // if ( router.currentRoute.name != 'Index' ) {
              router.push({ path: `/index?forward=${btoa(encodeURI((backURL)))}` })
            // }
            // if (!!authBackUrl) {
            //   window.open(authBackUrl, '_self')
            // } else {
            //   router.push({ path: `/index?forward=${btoa(encodeURI((backURL)))}` })
            // }
          }
        })
        return
      }
      return
    } else {
      // token过期，重新登录
      MessageBox.alert(lang[langCountry].Your_login_status_has_expired_please_log_in_again, lang[langCountry].Permission_error, {
        type: 'error',
        callback: () => {
          store.dispatch('token', {})
          store.dispatch('user', {})
          // if ( router.currentRoute.name != 'Index' ) {
            router.push({ path: `/index?forward=${btoa(encodeURI((backURL)))}` })
          // }
          // window.location.replace(`/index?forward=${location.pathname}`)
          // if (!!authBackUrl) {
          //   window.open(authBackUrl, '_self')
          // } else {
          //   router.push({ path: `/index?forward=${btoa(encodeURI((backURL)))}` })
          // }
        }
      })
      // 没有登录，去登录页
      return
    }
    resolve()
  })
}
